// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__pepKq","col":"styles_col__ph7jC"};